var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPstLogoSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.15045H11.0345C12.3742 4.15229 13.5673 4.68949 14.4488 5.57073C15.3248 6.4538 15.8618 7.65331 15.8636 8.99816C15.8618 10.343 15.3267 11.5407 14.4488 12.4256C13.5691 13.305 12.3742 13.844 11.0345 13.8459H0V18H11.0345C13.5032 18.0018 15.7573 16.99 17.3738 15.3637C18.992 13.741 20 11.4781 20 9C20.0018 6.52187 18.9939 4.25899 17.3738 2.63634C15.7573 1.01186 13.5032 0 11.0345 0H0V4.15045Z",
    fill: "#45C8CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 26V14H0V26",
    fill: "#45C8CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPstLogoSmall);
export default __webpack_public_path__ + "static/media/pst-logo-small.129656723a2349466cbb05d40fbaa342.svg";
export { ForwardRef as ReactComponent };